import shortid from 'shortid';

import { ROUTES } from 'src/constants';

import { NavToolbar } from 'components/NavToolbar';

import { t } from 'utils';

function Toolbar() {
  const items = [
    { key: shortid(), path: ROUTES.campaignLinks, label: t.staticAsString('campaignLinks.title') },
    { key: shortid(), label: t.staticAsString('campaignLinks.details') },
  ];
  return (
    <div className='toolbar'>
      <NavToolbar items={items} />
    </div>
  );
}

export { Toolbar };
